<template>
  <b-modal id="view_tax_file_modal" ref="view_tax_file_modal" hide-footer no-close-on-esc no-close-on-backdrop>
    <div slot="modal-header" class="mh">
      <div id="mh-text">
        <h1><i class="far fa-sticky-note"></i> {{ tax_file_type }}</h1>

        <p id="mh-info" v-if="notEmptyObject(file_uploaded_by)">
          Uploaded by
          <span>{{ file_uploaded_by.first_name }} {{ file_uploaded_by.surname }}</span>
          on {{ file_uploaded_date | formatDate }}
        </p>

      </div>
      <button id="mh-close" class="btn-close" @click="hideModal()"><i class="fas fa-times"></i></button>
    </div>

    <img v-if="file_type === 'jpg' || file_type === 'JPG' || file_type === 'png' || file_type === 'PNG' || file_type === 'jpeg' || file_type === 'JPEG' || file_type === 'gif' ||
  file_type === 'GIF' || file_type === 'bmp' || file_type === 'BMP'" :src="file_path" style="max-width: 100%; display: block;" alt="uploaded file"/>

    <div v-if="file_type === 'pdf' || file_type === 'PDF' ">
      <object :data="file_path" type="application/pdf" style="width: 100%; min-height: 400px;">
        alt : <a :href="file_path">{{ file_name }}</a>
      </object>
    </div>

    <div v-if="file_type === 'doc' || file_type === 'DOC' || file_type === 'docx' || file_type === 'DOCX'">
      Download word document : <a :href="file_path">{{ file_name }}</a>
    </div>
    <div v-if="file_type === 'tif' || file_type === 'TIF' || file_type === 'tiff' || file_type === 'TIFF'">
      Download TIF/TIFF image file : <a :href="file_path">{{ file_name }}</a>
    </div>

  </b-modal>
</template>

<script>
export default {
  name: "view_tax_file",
  data() {
    return {
      crm_url: process.env.MIX_APP_URL,
      tax_file_type: this.$store.state.files.tax_file.tax_file_type,
      temp_file_path: this.$store.state.files.tax_file.file_path,
      file_uploaded_by: this.$store.state.files.tax_file.file_uploaded_by,
      file_uploaded_date: this.$store.state.files.tax_file.file_uploaded_date,
    }
  },
  computed: {
    file_path() {
      return this.crm_url + '/' + this.temp_file_path.replace(/^public/gi, 'storage');
    },
    file_type() {
      return /[^.]*$/.exec(this.file_path)[0];
    },
    file_name() {
      return /[^\/]*$/.exec(this.file_path)[0];
    }
  },
  methods: {
    hideModal() {
      this.$refs.view_tax_file_modal.hide();
      this.$store.commit('HIDE_FILE_TAX_MODAL');
    },
  }
}
</script>
